import React from 'react';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonSpinner, withIonLifeCycle, IonCheckbox, IonButtons, IonBackButton, IonFab, IonFabButton, IonIcon, IonInput, IonRow, IonCol, IonGrid } from '@ionic/react';
import './WishList.css';
import { withRouter } from 'react-router';
import { GetResult, Storage } from '@capacitor/storage';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { add, handLeftOutline, personCircleOutline } from 'ionicons/icons';
import { backendUrl, getJson, isWeb, postJson } from '../fetchFunctions';
import TriCheckBox from './TriCheckBox';
import { error } from '../components/ToastController';
import { Friends }  from './Friends';

class Wish extends React.Component<any, any> {
	constructor(props: any) {
		super(props);
	}

	render() {

		if (this.props.owned) {
			return (
				<IonRow style={{ backgroundColor: "#fafafa", margin: "4px" }}>
					<IonCol size="10" style={{display: "flex", alignItems: "center"}}>
						<i className="pi pi-bars" style={{ fontSize: "20px" }} />
						<h3 style={{display: "inline-block", marginLeft: "20px", width: "100%", overflow: "hidden", textOverflow: "ellipsis"}}>{this.props.label}</h3>
					</IonCol>
					<IonCol size="2">
						<i className="pi pi-pencil" onClick={() => this.props.onEdit(this.props.id)} style={{ fontSize: "20px", position: "absolute", right: "30px", transform: "translateY(75%)" }} />
					</IonCol>
				</IonRow>
			)
		}
		else {
			return (
				<IonRow style={{ paddingLeft: "10px" }}>
					<IonCol size={"8"} style={{ display: "flex", alignItems: "center" }}>
						<div>
							<TriCheckBox
								disabled={this.props.wish?.checkState !== 0 && this.props.wish?.checkerPerson?.publicKey !== this.props.myPublicKey} 
								value={this.props.checkState} 
								onChange={(value: any) => this.props.onWishCheckChanged(this.props.id)} 
							/>
						</div>
						<h3 style={{display: "inline-block", marginLeft: "20px", width: "100%", overflow: "hidden", textOverflow: "ellipsis"}}>{this.props.label}</h3>
					</IonCol>
					<IonCol size="2" style={{marginTop: "8px", display: "flex", color: "#3567FF", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
						{this.props.wish?.checkState !== 0 && this.props.wish?.checkerPerson?.publicKey !== this.props.myPublicKey &&
							<div style={{width: "100%"}}>
								<div>
									<IonIcon style={{fontSize: "24px", position: "relative", left: "50%", transform: "translateX(-50%)"}} icon={personCircleOutline} />
								</div>
								<div style={{width: "100%", color: "#3567FF", fontSize: "10px", textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>
									{this.props.wish?.checkerPerson?.name}
								</div>
							</div>
						}
					</IonCol>
					{this.props.editable && 
						<IonCol size="2">
							<i className="pi pi-pencil" onClick={() => this.props.onEdit(this.props.id)} style={{ fontSize: "20px", position: "absolute", right: "30px", transform: "translateY(75%)" }} />
						</IonCol>
					}
				</IonRow>
			)
		}

	}
}

class WishList extends React.Component<any, any> {

	private newWishRef: any;

	constructor(props: any) {
		super(props);
		this.state = {
			name: "",
			notPublic: false,
			//Only used when accessing own wishes
			privateKey: "",
			publicKey: "",
			otherPublicKey: "",
			loading: true,
			dialogShown: false,
			newWishDialogShown: false,
			newWishName: "",
			newWishCheckState: 0,
			editedWish: {},
			updatingWish: false,
			deletingWish: false,
			addingWish: false,

			shareListDialogShown: false,

			items: []
		}
		this.newWishRef = React.createRef();
	}

	fetchOwnWishes = async (clientId: string) => {
		await getJson("wish/getOwn/" + clientId).then(async (response) => {
			if(response.ok) {
				await response.json().then((items: any) => {
					this.setState({items: items, loading: false});
					console.log(items);
				}).catch((ex: any) => error(ex));
			}
			else {
				response.text().then((text: any) => console.error("[wish list fetch own wishes] error code " + response.status + ", msg: " + text));
			}
		})
	}

	//Used when navigating to a friends list, instead of your own
	fetchOtherWishes = async (privateKey: string) => {
		await getJson("wish/getOther/" + privateKey + "/" + this.state.otherPublicKey).then(async (response) => {
			if(response.ok) {
				await response.json().then((items: any) => {
					this.setState({items: items, loading: false});
				}).catch((ex: any) => error(ex));
			}
			else if(response.status === 401) 
			{
				this.setState({notPublic: true})
			}
			else if(response.status > 0) {
				response.text().then((text: any) => console.error("[wish list fetch other wishes] error code " + response.status + ", msg: " + text));
			}
		})
	}

	private refreshIntervalId: any;

	ionViewWillEnter() {
		Friends.stopRefreshing();
		this.setState({ loading: true, notPublic: false });
		
		Storage.get({ key: "clientId" }).then((result: GetResult) => {
			console.log("got client id " + result.value)


			getJson("users/get/private/" +  result.value).then(response => {
				if(response.ok) {
					response.json().then(async (user: any) => {
						if(result.value)
						{
							await this.setState({privateKey: result.value, publicKey: user.publicKey});
							if(this.props.me)
							{
								this.setState({name: user.name})
								this.fetchOwnWishes(result.value);
							}
							else {

								let params = new URLSearchParams(this.props.history.location.search);
								if (params.has("id")) {
									let id = params.get("id");
									this.setState({otherPublicKey: id}, () => this.fetchOtherWishes(this.state.privateKey))
									
									getJson("users/get/public/" + id).then(response => {
										if(response.ok) {
											response.json().then((other: any) => {
												this.setState({name: other.name})
											})
										}
										else if(response.status > 0) response.text().then((text: any) => error("[wish list get other name] error code " + response.status + ", msg: " + text));
									})
								}
							}
						}
					})
				}
				else if(response.status > 0) 
					response.text().then((text: any) => error("[wish list get own user] error code " + response.status + ", msg: " + text));
			}).catch(ex => error("Failed to connect!"))

			//Fetch id from storage
			if(this.props.me) {
				
			}
			else {

			}

			//Get user name
			
		}).catch(ex => console.error(ex));

		this.refreshIntervalId = setInterval(() => {
			if(this.state.privateKey && this.state.privateKey.length > 0) {
				if(this.props.me) {
					this.fetchOwnWishes(this.state.privateKey)
				}
				else 
					this.fetchOtherWishes(this.state.privateKey)
			}
		}, 1000);
		
	}

	ionViewWillLeave() {
		clearInterval(this.refreshIntervalId);
	}

	onWishDragged = (result: any, provided: any) => {
		console.log(result);
		let wishId = result.draggableId;
		let destinationIndex = result.destination.index;

		let wishItemIndex = this.state.items.findIndex((wish: any) => wish.id === wishId);
		let wishItem = this.state.items[wishItemIndex];

		/*
		//For some reason, on phones, the dragging is moving 1 too much up when moving upwards.
		//So we compensate for that here by adding to the destination index.
		if(isWeb() == false && destinationIndex < wishItem.index) {
			destinationIndex++;
		}*/

		wishItem.index = destinationIndex;
		this.updateOwnWish(wishItem);
	}

	onWishEdit = (id: string) => {
		let wish = this.state.items.find((wish: any) => wish.id === id);
		if (wish) {
			this.setState({ editedWish: wish, dialogShown: true, updatingWish: false, deletingWish: false });
		}
	}

	updateOwnWish = (item: any) => {
		postJson("wish/changeOwn", {
			privateKey: this.state.privateKey,
			item: item
		}).then(async (response) => {
			if(response.ok) {
				await this.fetchOwnWishes(this.state.privateKey);
				this.setState({updatingWish: false, dialogShown: false})
			}
			else if(response.status > 0) 
				response.text().then((text: any) => error("[onWishUpdate] error code " + response.status + ", msg: " + text));
		})
	}

	onWishUpdate = () => {
		this.setState({ updatingWish: true });
		let item = this.state.editedWish;

		//TODO fetch request to update externally

		//Here we can only change the name
		console.log({
			privateKey: this.state.privateKey,
			item: item
		})
		postJson("wish/changeName", {
			privateKey: this.state.privateKey,
			item: item
		}).then(async (response) => {
			if(response.ok) {
				if(this.props.me)
					await this.fetchOwnWishes(this.state.privateKey);
				else 
					await this.fetchOtherWishes(this.state.privateKey);
				this.setState({updatingWish: false, dialogShown: false})
			}
			else if(response.status > 0) 
				response.text().then((text: any) => {error("[change name] error code " + response.status + ", msg: " + text); console.error(text)});
			})
	}

	onWishDelete = () => {
		this.setState({ deletingWish: true })
		let wishToDelete = this.state.editedWish;

		postJson("wish/delete", {
			privateKey: this.state.privateKey,
			wishId: wishToDelete.id
		}).then(async (response) => {
			if(response.ok) {
				if(this.props.me) {
					await this.fetchOwnWishes(this.state.privateKey);
				}
				else {
					await this.fetchOtherWishes(this.state.privateKey);
				}
				this.setState({deletingWish: false, dialogShown: false})
			}
			else
			{
				if(response.status > 0)
					response.text().then((text: any) => error("[wish list delete wish] error code " + response.status + ", msg: " + text));
				this.setState({deletingWish: false})
			}
		})
	}

	onWishCheckChanged = (wishId: string) => {
		console.log(wishId)
		let items = this.state.items;
		let currentWish = items.find((wish: any) => wish.id === wishId);
		console.log(currentWish)
		if (currentWish) {
			if (currentWish.checkState === 0 || (currentWish.checkerPerson?.publicKey === this.state.publicKey)) {
				let newValue = 0;
				if (currentWish.checkState === 0)
					newValue = 1;
				else if (currentWish.checkState === 1)
					newValue = 2;
				else newValue = 0;

				currentWish.checkerPerson = {publicKey: this.state.publicKey, name: ''};
				currentWish.checkState = newValue;

				this.setState({ items: items })
				console.log("new value: " + newValue)

				postJson("wish/setCheckState", {
					privateKey: this.state.privateKey,
					item: {
						id: wishId,
						checkState: newValue
					}
				}).then(response => {

				})

				//TODO Fetch request to update wish remotely
			}
		}
	}

	openAddWishDialog = () => {
		if(this.isLoggedIn()) {
			this.setState({newWishDialogShown: true, newWishName: "", newWishCheckState: 0, addingWish: false});
			this.newWishRef.current?.focus();
		}
		else {
			this.props.history.push("/?redirectTo=app/user/" + this.state.otherPublicKey);
		}
	}

	isLoggedIn = () => {
		return this.state.publicKey && this.state.publicKey.length > 5;
	}

	onSaveNewWish = () => {
		let newWish = {
			name: this.state.newWishName,
			state: this.state.newWishCheckState
		}
		this.setState({addingWish: true})


		//TODO fetch request to add wish

		//Add to general wish items
		if(this.props.me) {
			postJson("wish/addOwn", {
				privateKey: this.state.privateKey,
				name: newWish.name
			}).then(async (response) => {
				if(response.ok) 
				{
					await this.fetchOwnWishes(this.state.privateKey);
					this.setState({addingWish: false, newWishDialogShown: false});
				}
				else if(response.status > 0) {
					response.text().then((text: any) => error("[wish list add own wish] error code " + response.status + ", msg: " + text));
				}
			})
		}
		//Add to hidden wish items
		else {
			postJson("wish/addOther", {
				privateKey: this.state.privateKey,
				otherPublicKey: this.state.otherPublicKey,
				name: newWish.name,
				checkState: newWish.state
			}).then(async (response) => {
				if(response.ok) 
				{
					this.setState({addingWish: false, newWishDialogShown: false});
					await this.fetchOtherWishes(this.state.privateKey);
				}
				else if(response.status > 0) {
					response.text().then((text: any) => error("[wish list add own wish] error code " + response.status + ", msg: " + text));
				}
			})
		}
	}

	shareList = () => {
		this.setState({shareListDialogShown: true})
	}

	render() {
		return (
			<IonPage>
				{this.state.loading ?
					<div style={{ display: "flex", height: "100vh", justifyContent: "center", alignItems: "center" }}>
						<IonSpinner style={{ width: "10vw", height: "10vw" }} color="tertiary" name="lines-sharp" />
					</div>
					:
					<div>
						{this.state.notPublic ? 
							<div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
								<IonIcon icon={handLeftOutline} style={{fontSize: "20vw"}} />
								<div style={{fontSize: "20px", color: "#555", textAlign: "center"}}>Denne liste er ikke offentligt tilgængelig</div>
								<div style={{fontSize: "20px", color: "#666"}}>
									Måder det kan fikses på:
									<ul>
										<li>Få personen til at gøre listen offentlig</li>
										<li>Send vedkommende en venne anmodning</li>
									</ul>
								</div>
							</div>
						:
						<div>
							<IonHeader>
								<IonToolbar>
									{!this.props.me &&
										<IonButtons slot="start">
											<IonBackButton defaultHref="/app/tab2" />
										</IonButtons>
									}
									<IonTitle>{this.state.name}</IonTitle>
									{/* {this.props.me && 
										<IonButtons slot="end">
											<Button onClick={this.shareList} icon="pi pi-share-alt" className="p-button-text p-button-plain"></Button>
										</IonButtons>
									} */}
								</IonToolbar>
							</IonHeader>
							<IonContent fullscreen>
								<IonHeader collapse="condense">
									<IonToolbar>
										<IonTitle size="large">{this.state.name}</IonTitle>
									</IonToolbar>
								</IonHeader>
								<div style={{position: "fixed", bottom: "50px", left: "50%", transform: "translateX(-50%)", zIndex: 1000}}>
									<Button style={{backgroundColor: "white"}} className="p-button-rounded p-button-outlined" icon="pi pi-plus" onClick={this.openAddWishDialog}/>
								</div>
								<div style={{ }}>
									{this.props.me ?
										<DragDropContext onDragEnd={this.onWishDragged}>
											<IonGrid>
												{this.state.items.map((wish: any, index: number) => (
													<Droppable droppableId={wish.id} key={wish.id}>
														{provided => (
															<div ref={provided.innerRef} {...provided.droppableProps}>
																<Draggable draggableId={wish.id} index={index}>
																	{(provided) => (
																		<div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
																			<Wish
																				owned={this.props.me}
																				id={wish.id}
																				label={wish.name}
																				onEdit={this.onWishEdit}
																				checkState={wish.checkState}
																				onWishCheckChanged={this.onWishCheckChanged}
																			/>
																		</div>
																	)}
																</Draggable>
																{provided.placeholder}
															</div>
														)}
													</Droppable>
												))}
												{this.state.items.length === 0 && 
													<p style={{textAlign: "center", color: "#aaa"}}>Tom</p>
												}
											</IonGrid>
										</DragDropContext>
										:
										<>
											{this.state.items.map((wish: any, index: number) => (
												<Wish 
													key={wish.id}
													myPublicKey={this.state.publicKey}
													wish={wish}
													owned={this.props.me}
													editable={wish.otherCreatorPublicKey === this.state.publicKey && this.isLoggedIn()}
													id={wish.id}
													label={wish.name}
													onEdit={this.onWishEdit}
													checkState={wish.checkState}
													onWishCheckChanged={this.onWishCheckChanged}
												/>
											))}
										{this.state.items.length === 0 && 
											<p style={{textAlign: "center", color: "#aaa"}}>Tom</p>
										}
										</>
									}
								</div>
							</IonContent>
							<Dialog header="Rediger ønske  " visible={this.state.dialogShown} onHide={() => this.setState({ dialogShown: false })}>
								<div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>

									<InputText autoFocus={true} style={{ marginTop: "16px" }} value={this.state.editedWish.name} placeholder="Navn" onChange={e => this.setState({ editedWish: { id: this.state.editedWish.id, name: e.target.value } })} />

									<div style={{ marginTop: "50px", display: "flex", justifyContent: "center" }}>
										<Button onClick={this.onWishUpdate} disabled={this.state.deletingWish} loading={this.state.updatingWish} className="p-button-primary" style={{ marginRight: "20px" }} label="Gem" icon="pi pi-save" iconPos="left" />
										{(this.props.me || this.state.editedWish?.otherCreatorPublicKey === this.state.publicKey) &&
											<Button onClick={this.onWishDelete} disabled={this.state.updatingWish} loading={this.state.deletingWish} className="p-button-danger" label="Slet" icon="pi pi-trash" iconPos="right" />
										}
									</div>
								</div>
							</Dialog>

							<Dialog header="Nyt ønske" visible={this.state.newWishDialogShown} onHide={() => this.setState({ newWishDialogShown: false })}>
								<div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>

									<InputText autoFocus ref={this.newWishRef} style={{ marginTop: "16px" }} value={this.state.newWishName} placeholder="Navn" onChange={e => this.setState({ newWishName: e.target.value })} />
									
									{!this.props.me &&
										<div style={{marginTop: "30px"}} className="col-12">
											<TriCheckBox id="cb1" onChange={(value: any) => this.setState({newWishCheckState: value})} value={this.state.newWishCheckState}></TriCheckBox>
											<label htmlFor="cb1" className="p-checkbox-label" style={{marginLeft: "16px"}}>Start tjekket?</label>
										</div>
									}

									<div style={{ marginTop: "50px", display: "flex", justifyContent: "center" }}>
										<Button onClick={this.onSaveNewWish} disabled={this.state.newWishName.length === 0} loading={this.state.addingWish} className="p-button-primary" label="Tilføj" icon="pi pi-save" iconPos="left" />
									</div>
								</div>
							</Dialog>

							<Dialog header="Del Liste" visible={this.state.shareListDialogShown} onHide={() => this.setState({shareListDialogShown: false})}>
								<div style={{display: "flex", justifyContent: "center", flexDirection: "column", marginTop: "16px"}}>
									<InputText disabled={true} value={backendUrl() + "list?"}></InputText>

									{/* TODO Add the rest of this functionality. In order to do so, we need a PWA somewhere where we can link up with this generated url */}
								</div>
							</Dialog>
						</div>
					}
					</div>
				}
			</IonPage>
		);
	}

}

export default withRouter(withIonLifeCycle(WishList));
